// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import VueTour from 'vue-tour';
import BootstrapVue from "bootstrap-vue";
import VueCookies from 'vue-cookies';
import App from './App';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-tour/dist/vue-tour.css';
import VueClipboard from 'vue-clipboard2';

Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(VueTour);
Vue.use(ViewUI);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.config.productionTip = false;

//上次登录信息
Vue.prototype.setLastLoginInfo = function (loginInfo) {
    localStorage.setItem('bf_km_last_login', JSON.stringify(loginInfo));
};
Vue.prototype.getLastLoginInfo = function () {
    return JSON.parse(localStorage.getItem('bf_km_last_login'));
};

//种植地
Vue.prototype.setAddressStorage = function (address) {
    localStorage.setItem('bf_km_member_address', JSON.stringify(address));
};
Vue.prototype.removeAddressStorage = function () {
    localStorage.removeItem('bf_km_member_address');
};
Vue.prototype.getAddressInfo = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    return address;
};
Vue.prototype.getAddressContactInfo = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressContacts + ' ' + address.memberDeliveryAddressPhone;
    }
    else {
        return '';
    }
};
Vue.prototype.getAddressUuid = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressUuid;
    }
    else {
        return '';
    }
};
Vue.prototype.getAddressType = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressType;
    }
    else {
        return '';
    }
};
Vue.prototype.getAddressDistUuid = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressDistUuid;
    }
    else {
        return '';
    }
};
Vue.prototype.getAddressName = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressCompanyName;
    }
    else {
        return '';
    }
};
Vue.prototype.getStationUuid = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.memberDeliveryAddressStationUuid;
    }
    else {
        return '';
    }
};
Vue.prototype.getStationName = function () {
    let address = JSON.parse(localStorage.getItem('bf_km_member_address'));
    if (address) {
        return address.distributionStationName;
    }
    else {
        return '';
    }
};

Vue.prototype.checkMemberLogin = function () {
    return this.$cookies.isKey('bf_km_member_name');
};
Vue.prototype.setLoginCookies = function (loginToken, uuid, name, userType) {
    this.$cookies.set("bf_km_member_login_token", loginToken);
    this.$cookies.set("bf_km_member_uuid", uuid);
    this.$cookies.set("bf_km_member_name", name);
    this.$cookies.set("bf_km_member_userType", userType);
};
Vue.prototype.clearLoginCookies = function () {
    this.$cookies.remove("bf_km_member_login_token");
    this.$cookies.remove("bf_km_member_uuid");
    this.$cookies.remove("bf_km_member_name");
    this.$cookies.remove("bf_km_member_userType");
};
Vue.prototype.checkIsSalesMan = function () {
    return this.$cookies.get('bf_km_member_userType') === 'G';
};
Vue.prototype.getLoginCookieUserType = function () {
    return this.$cookies.get('bf_km_member_userType');
};
Vue.prototype.getLoginCookieName = function () {
    return this.$cookies.get('bf_km_member_name');
};
Vue.prototype.getLoginCookieUuid = function () {
    return this.$cookies.get('bf_km_member_uuid');
};
Vue.prototype.getLoginCookieLoginToken = function () {
    return this.$cookies.get('bf_km_member_login_token');
};

Vue.prototype.$downLoadFile = function (url) {
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    let fileName = url.split('/').pop();
    link.setAttribute("download", fileName); //指定下载后的文件名，防跳转
    document.body.appendChild(link);
    link.click();
};

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js